// extracted by mini-css-extract-plugin
export default {"google-rating":"google_google-rating__MxXEM","hover":"google_hover__PK90K"};